import(/* webpackMode: "eager" */ "/build/51dfc355-2bcd-434f-bd83-5aedefdcdd3a/frontend/src/app/error.tsx");
